var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26309 21.9641L6.03809 20.7391L12.7756 14.0016L6.03809 7.26406L7.26309 6.03906L14.0006 12.7766L20.7381 6.03906L21.9631 7.26406L15.2256 14.0016L21.9631 20.7391L20.7381 21.9641L14.0006 15.2266L7.26309 21.9641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/close_1.0bec765f4695c045ac412436f647e419.svg";
export { ForwardRef as ReactComponent };